import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '@websky/core/src/theme';
import { useTranslation } from 'react-i18next';
import theme from './BaggageInfo.css';
import { Money } from '@websky/core/src';
import { initI18n } from '@websky/core/src/utils';
initI18n('baggageService2');
const BaggageInfo = props => {
    const { baggage, selected, showMinPrices } = props;
    const { t } = useTranslation();
    const { Baggage: css } = useTheme('Baggage');
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: theme.size__wrapper },
            React.createElement("div", { className: theme.weight }, baggage.value.amount),
            React.createElement("div", null, t(baggage.value.measurement))),
        React.createElement("div", { className: cn(css.name, theme.name) }, baggage.name),
        React.createElement("div", { className: cn(css.size, theme.measurement) }, baggage.size),
        showMinPrices && !selected && (React.createElement("div", { className: theme.price__wrp },
            React.createElement("div", { className: theme.price },
                t('baggageService2:From'),
                " ",
                React.createElement(Money, { money: baggage.price }))))));
};
export default BaggageInfo;
